module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "border",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12 sm8"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('galva', {
    staticClass: "left-element",
    attrs: {
      "name": "ÉNERGIE",
      "size": 120,
      "domain": {
        inf: 0.,
        sup: _vm.nutrientLimSupDict['208']
      },
      "norm": {
        d1: _vm.nutrientRangeDict['208'].d1,
        d2: _vm.nutrientRangeDict['208'].d2,
        dt1: _vm.nutrientRangeDict['208'].dt1,
        dt2: _vm.nutrientRangeDict['208'].dt2,
        h: 0
      },
      "value": {
        d1: _vm.nutrientDict['208'].d1,
        d2: _vm.nutrientDict['208'].d2,
        dt1: _vm.nutrientDict['208'].dt1,
        dt2: _vm.nutrientDict['208'].dt2,
        h: 0
      }
    }
  }), _vm._v(" "), _c('galva', {
    staticClass: "left-element",
    attrs: {
      "name": "LIPIDES",
      "size": 100,
      "domain": {
        inf: 0.,
        sup: _vm.nutrientLimSupDict['204']
      },
      "norm": {
        d1: _vm.nutrientRangeDict['204'].d1,
        d2: _vm.nutrientRangeDict['204'].d2,
        dt1: _vm.nutrientRangeDict['204'].dt1,
        dt2: _vm.nutrientRangeDict['204'].dt2,
        h: 0
      },
      "value": {
        d1: _vm.nutrientDict['204'].d1,
        d2: _vm.nutrientDict['204'].d2,
        dt1: _vm.nutrientDict['204'].dt1,
        dt2: _vm.nutrientDict['204'].dt2,
        h: 0
      }
    }
  }), _vm._v(" "), _c('galva', {
    staticClass: "left-element",
    attrs: {
      "name": "GLUCIDES",
      "size": 100,
      "domain": {
        inf: 0.,
        sup: _vm.nutrientLimSupDict['205']
      },
      "norm": {
        d1: _vm.nutrientRangeDict['205'].d1,
        d2: _vm.nutrientRangeDict['205'].d2,
        dt1: _vm.nutrientRangeDict['205'].dt1,
        dt2: _vm.nutrientRangeDict['205'].dt2,
        h: 0
      },
      "value": {
        d1: _vm.nutrientDict['205'].d1,
        d2: _vm.nutrientDict['205'].d2,
        dt1: _vm.nutrientDict['205'].dt1,
        dt2: _vm.nutrientDict['205'].dt2,
        h: 0
      }
    }
  }), _vm._v(" "), _c('galva', {
    staticClass: "left-element",
    attrs: {
      "name": "PROTIDES",
      "size": 100,
      "domain": {
        inf: 0.,
        sup: _vm.nutrientLimSupDict['203']
      },
      "norm": {
        d1: _vm.nutrientRangeDict['203'].d1,
        d2: _vm.nutrientRangeDict['203'].d2,
        dt1: _vm.nutrientRangeDict['203'].dt1,
        dt2: _vm.nutrientRangeDict['203'].dt2,
        h: 0
      },
      "value": {
        d1: _vm.nutrientDict['203'].d1,
        d2: _vm.nutrientDict['203'].d2,
        dt1: _vm.nutrientDict['203'].dt1,
        dt2: _vm.nutrientDict['203'].dt2,
        h: 0
      }
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm4"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('badge', {
    staticClass: "right-element",
    attrs: {
      "mark": _vm.mealMark,
      "size": 120,
      "backColor": "#8c6e64",
      "frontColor": "white"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6d0e94a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nutrieduc/MealAssessment.vue
// module id = 1211
// module chunks = 1